const API_ERR_CODES = {
  502:
  {
    message: "We are offline for maintenance. Please try later",
  },
	4003: {
		message: "Invalid credentials",
	},
	4004: {
		message: "Oops! Something went wrong, we are working on it.",
	},
};

export const getErrMsg = (err, defaultMsg) => {
  // Can add default messages depending on the error status sent from API
  if (!err) {
    return defaultMsg || "Oops! Something went wrong. Please try later";
  }
  console.error(err);
  if (err.code && API_ERR_CODES[err.code] ) { // Does not work. Not currently returning an error code
    return API_ERR_CODES[err.code].message;
  }
	return typeof err === "string" ? err || defaultMsg : err?.message || defaultMsg || "Oops! Something went wrong. Please try later";
};
